import { render, staticRenderFns } from "./deleteItemReleaseType.vue?vue&type=template&id=219f2db8"
import script from "./deleteItemReleaseType.vue?vue&type=script&lang=js"
export * from "./deleteItemReleaseType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports